// 'use strict';

angular.module("screensApp").factory("MainService", function ($http, $rootScope) {
  return {
    /**
     * @returns {HttpPromise}
     */
    getLabels: function () {
      return $http.get("data/labels.json", { withCredentials: true });
    },

    /**
     * Load server time
     * @returns {HttpPromise}
     */
    getServerTime: function () {
      return $rootScope.setOfferUrl("TimeStamp/Zone/" + $rootScope.config.TimeZone, true);
    }
  }
});
